import React from 'react';

import { FormControlLabel, Checkbox, FormGroup, Paper } from '@material-ui/core';
import MaterialTable from 'material-table';

import file from '../../../assets/excelFile.svg'
import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';
import { UnScreenedData, UnScreenedFilter } from '../../../models/Analytics';

interface UnscreenedShipmentsProps {
  shipments: UnScreenedData[];
  shipmentFilter: UnScreenedFilter;
  handleExport: (type: string) => void;
  handleChangeShipmentFilter: (type: string, event: boolean) => void;
};

const UnscreenedShipments = (props: UnscreenedShipmentsProps) => {
  return (
    <div className={`${styles.wtOuterGridItems}`}>
      <div className={`${commonStyles.fSpaceBtw} ${commonStyles.flexWrap} ${commonStyles.mb4}`}>
        <h5 className={styles.heading}>Unscreened Shipments</h5>
        <div className={`${styles.fileImg}`} onClick={() => props.handleExport('shipments')}>
          <img src={file} alt="file" />
        </div>
      </div>
      <FormGroup
        row={true}
        className={`${styles.ussFormGroup}`}>
        <small className={`${commonStyles.pr2}`}>Exclude:</small>
        <FormControlLabel
          control={
            <Checkbox
              name="transit_shipments"
              color="primary"
              size="small"
            />
          }
          label="Transit Shipments"
          checked={props.shipmentFilter.transit}
          onClick={() => props.handleChangeShipmentFilter('transit', !props.shipmentFilter.transit)}
          className={styles.exclCheckbox}
        />
        <FormControlLabel
          control={
            <Checkbox
              name="interline_transfers"
              color="primary"
              size="small"
            />
          }
          label="Interline Transfers"
          checked={props.shipmentFilter.interline}
          onClick={() => props.handleChangeShipmentFilter('interline', !props.shipmentFilter.interline)}
          className={styles.exclCheckbox}
        />
        <FormControlLabel
          control={
            <Checkbox
              name="ccsf"
              color="primary"
              size="small"
            />
          }
          label="CCSF"
          checked={props.shipmentFilter.ccsf}
          onClick={() => props.handleChangeShipmentFilter('ccsf', !props.shipmentFilter.ccsf)}
          className={styles.exclCheckbox}
        />
        <FormControlLabel
          control={
            <Checkbox
              name="its"
              color="primary"
              size="small"
            />
          }
          label="ITS"
          checked={props.shipmentFilter.its}
          onClick={() => props.handleChangeShipmentFilter('its', !props.shipmentFilter.its)}
          className={styles.exclCheckbox}
        />
      </FormGroup>
      <MaterialTable
        components={{ Container: props => <Paper {...props} elevation={0} className={`${commonStyles.paperTable} ${styles.anayTable}`} /> }}
        data={props.shipments}
        columns={[
          { title: 'AWB', field: 'awb', type: 'numeric' },
          { title: 'Org', field: 'org' },
          { title: 'Des', field: 'dest' },
          { title: 'Pcs', field: 'pcs', type: 'numeric' },
          { title: 'Wgt', field: 'wgt', type: 'numeric' },
          { title: 'Out Flt', field: 'out_flt' },
          { title: 'FWD/INT/RFS', field: 'fwd' },
          { title: 'Rcvd By', field: 'rcvd_by' },
          { title: 'Rcv Time', type: 'datetime', field: 'rcvd_time' },
        ]}
        options={{
          paging: false,
          pageSize: 10,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
            textAlign: 'center',
            fontWeight: 600,
          },
          maxBodyHeight: '400px',
          showTitle: false,
          pageSizeOptions: [15, 20],
          toolbar: false,
          sorting: false
        }}
      />
    </div>
  );
};

export default UnscreenedShipments;